import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { BaseDialog } from "../../../../base-dialog";
import { ComunicadosService } from "src/app/services/api/comunicados.service";

@Component({
  selector: "mandae-popup-notificacao",
  templateUrl: "./modal.component.html"
})
export class ModalComunicadosComponent
  extends BaseDialog<ModalComunicadosComponent>
  implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) private data,
    dialogRef: MatDialogRef<ModalComunicadosComponent>,
    public comunicadosService: ComunicadosService,
  ) {
    super(dialogRef);
  }

  ngOnInit() {}

  public async ciente() {
    try {
      const user = localStorage.getItem('ls.user')
        ? JSON.parse(localStorage.getItem('ls.user'))
        : null;

      if (!user) {
        this.dialogRef.close(false);
        return;
      }

      const data = {
        idCliente: user.id,
        idComunicado: this.data.idComunicado
      };

      await this.comunicadosService.setAceiteComunicado(data);

      this.dialogRef.close(true);
    } catch (error) {
      console.error("Erro ao dar ciente em comunicado", error);
      this.dialogRef.close(false);
    }
  }
}
